const getTWA = () => window.Telegram.WebApp;

export { getTWA };
